import { get } from 'lodash';

import { HEX_VALUES } from './constants';

export { HEX_VALUES };

const Colors = class {
  static getHex = hue => get(HEX_VALUES, hue);
};

export default Colors;
